import { gql } from "@apollo/client";

export const pageApplicationUsers = gql`
query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageApplicationUsers(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        id
        name
        adId
        emailAddress
      }
    }
}
`;

export const readRoles = gql`
query($id: Float!){
    readOneApplicationUser(id: $id){
        id
        name
        adId 
        emailAddress
        applicationUserRoles{
            id
            role{
                id
                roleType
            }
            department{
                id
                Abbreviation
            }
            isDefaultRole
        }
    }
}
`

export const updateRunAsMutation = gql`
mutation($srcUser: Float, $destUser: Float!, $reset: Boolean){
    updateUserForRunAs(srcUser: $srcUser, destUser: $destUser, reset: $reset){
        id
        name
        adId
        emailAddress
        updatedBy
    }
}
`